module.exports = __webpack_public_path__ + "static/media/bg-home-header.a8340e53.png";